import type { TFunction } from "i18next";

/**
 * What kind of place a chat row is, in words a guest reads.
 *
 * Explore rows have no category, so the rows fell back to the raw `segment`
 * value and printed "locations · Marrakech" under the Musée de Marrakech and
 * "stays" under a riad (seen 2026-10-28). The category name still wins; the
 * segment is translated; anything unknown is left out rather than shown raw.
 */
const SEGMENTS = ["locations", "restaurants", "stays", "spas", "guides"] as const;
type Segment = (typeof SEGMENTS)[number];

export function kindLabel(
  t: TFunction,
  match: { categoryName?: string | null; segment?: string | null },
): string | null {
  if (match.categoryName) return match.categoryName;
  const segment = match.segment?.trim().toLowerCase();
  if (segment && (SEGMENTS as readonly string[]).includes(segment)) {
    return t(`ai_concierge.kind.${segment as Segment}`);
  }
  return null;
}
